let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("17m16"), load("kAg8V"), load("cMubu"), load("9Cdzw"), load("cHWSM"), load("35Ssm")]).then(() => parcelRequire('ViizB'));